// 职业规划聊天记录
import React from 'react'

import Config from '../../config/Config';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';


class CareerCard extends React.Component 
{
    constructor( props )
    {
        super(props);

        this.state = {
            sourcePath: Config.getSourcePath(),
        }
    }

    notify = ( item ) => {

        if( this.props.notify )
        {
            this.props.notify(item);
        }
    }   

    render()
    {
        const { data } = this.props;

        const { sourcePath } = this.state; 

        return ( 
            <div className='sf-career-card' >
            {
                data.map((item, index) => {
                    return (
                        <div className='sf-career-card-item' key={index + item.key} onClick={ () => {this.notify(item)} }>
                            <div className='sf-career-card-icon'> <img src={require('./../../img/' + sourcePath + '/component/career-icon.png')}></img></div>
                            <div className='sf-career-card-item-row'> 
                                <div className='sf-career-card-item-row-body'>
                                    <div className='sf-career-card-item-title'>{item.title}</div>
                                    <div className='sf-career-card-item-date'>
                                        <span>{item.date}</span>
                                    </div>
                                </div>
                                <div className='sf-career-card-item-description'>{item.description}</div>
                            </div>
                        </div>
                    )
                })
            }
            </div>
        )
    }
}

export default CareerCard